import { useCurrentDomain } from '@/shared/lib/hooks/use-current-domain.hook';

import { DOMAIN_ROUTES } from '../constants/domain-routes.constant';
import { MultiRoutes } from '../types/navigation-item.interface';

export const useRoutes = (): MultiRoutes => DOMAIN_ROUTES[useCurrentDomain()];
